const FETCH_SPONSORED = 'frontend/products/FETCH_SPONSORED';

const initialState = null;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SPONSORED:
      return action.payload;
    default:
      return state;
  }
}
